import { IonIcon, IonLabel, IonRouterOutlet, IonTabBar, IonTabButton, IonTabs } from '@ionic/react'
import { attachOutline, bookmarkOutline, readerOutline, shareOutline, stopwatchOutline } from 'ionicons/icons'
import React, { useEffect } from 'react'
import { Redirect, useHistory } from 'react-router-dom'
import Timeline from '../../features/timeline/page/Timeline.page'
import Times from '../../features/times/page/Times.page'
import QuickActions from '../../features/quickActions/page/QuickActions.page'
import Attach from '../../features/attachments/page/Attachments.page'
import './Tabs.component.css'
import Vitals from '../../features/vitals/page/Vitals.page'
import { TabConstants } from './Tabs.constants'
import { AppRouterConstants } from '../appRouter/AppRouter.constants'
import PatientInformation from '../../features/patientInformation/page/PatientInformation.page'
import CardiacArrest from '../../features/quickActions/cardiacArrest/page/CardiacArrest.page'
import { QuickActionsConstants } from '../../features/quickActions/store/quickActions.constants'
import PatientDemographics from '../../features/patientDemographics/page/PatientDemographics.page'
import FullChart from '../../features/fullChart/page/FullChart.page'
import PatientAllergies from '../../features/patientAllergies/page/PatientAllergies.page'
import PatientMedications from '../../features/patientMedications/page/PatientMedications.page'
import PatientAllergiesSearchList from '../../features/patientAllergies/page/PatientAllergiesSearchList.page'
import PatientMedicalHistory from '../../features/patientMedicalHistory/page/PatientMedicalHistory.page'
import MedicalHistoryLookup from '../../features/patientMedicalHistory/medicalHistoryLookup/MedicalHistoryLookup.component'
import MedicationSearch from '../../features/patientMedications/medicationsSearch/MedicationsSearch.component'
import CardiacProcedure from '../../features/procedures/cardiac/page/Cardiac.page'
import ActionsSearch from '../../features/timeline/actionsSearch/ActionsSearch.component'
import AddMedicationAdministered from '../../features/addMedicationAdministered/page/AddMedicationAdministered.page'
import MedicationAdministeredSearch from '../../features/addMedicationAdministered/medicationAdministeredSearch/MedicationAdministeredSearch.component'
import QuickActionButtons from '../../features/quickActions/quickActionButtons/page/QuickActionButtons.page'
import Intubation from '../../features/intubation/page/Intubation.page'
import TripInformation from '../../features/tripInformation/page/TripInformation.page'
import PickupAddress from '../../features/pickupAddress/page/PickupAddress.page'
import Airway from '../../features/procedures/airway/page/Airway.page'
import ImagingUltrasoundProcedure from '../../features/procedures/imagingUltrasound/page/ImagingUltrasound.page'
import ChildbirthOB from '../../features/procedures/childbirthOB/page/childbirthOB.page'
import InitiateIV from '../../features/procedures/initiateIv/page/initiateIv.page'
import Immobilization from '../../features/procedures/immobilization/page/immobilization.page'
import MedicalConsult from '../../features/procedures/medicalConsult/page/medicalConsult.page'
import Extrication from '../../features/procedures/extrication/page/extrication.page'
import Operations from '../../features/procedures/operations/page/operations.page'
import Rescue from '../../features/procedures/rescue/page/rescue.page'
import Ventilator from '../../features/procedures/ventilator/page/ventilator.page'
import HospitalNotify from '../../features/procedures/hospitalNotify/page/hospitalNotify.page'
import WoundCare from '../../features/procedures/woundCare/page/woundCare.page'
import PatientNarrative from '../../features/narrative/page/PatientNarrative.page'
import CadImport from '../../features/cadImport/page/CadImport.page'
import CcHpi from '../../features/ccHpi/page/ccHpi.page'
import { useSelector } from 'react-redux'
import { IRootState } from '../../store'
import DestinationAddress from '../../features/destinationAddress/page/DestinationAddress.page'
import PatientBilling from '../../features/billing/page/Billing.page'
import InsuranceInformation from '../../features/insuranceInformation/page/InsuranceInformation.page'
import RelationshipsAndGuarantors from '../../features/relationshipsAndGuarantors/page/RelationshipsAndGuarantors.page'
import PcsInformation from '../../features/pcsInformation/page/PcsInformation.page'
import AuthorizationInformation from '../../features/authorizationInformation/page/AuthorizationInformation.page'
import CmsInformation from '../../features/cmsInformation/page/CmsInformation.page'
import PaymentInformation from '../../features/paymentInformation/page/paymentInformationPage'
import PatientSearch from '../../features/patientSearch/page/PatientSearch.page'
import PatientSearchResults from '../../features/patientSearch/page/PatientSearchResults.page'
import FactorsAffectingCare from '../../features/factorsAffectingCare/page/FactorsAffectingCare.page'
import SceneDescription from '../../features/sceneDescription/page/SceneDescription.page'
import InitialAssessment from '../../features/initialAssessments/page/InitialAssessment.page'
import InitialAssessmentComments from '../../features/initialAssessments/comments/InitialAssessmentComments'
import GlassgowCommaScore from '../../features/initialAssessments/neuro/glassgowCommaScore/page/GlassgowCommaScore.page'
import PediatricCommaScore from '../../features/initialAssessments/neuro/pediatricTraumaScore/page/PediatricTraumaScore.page'
import RevisedTraumaScore from '../../features/initialAssessments/neuro/revisedTraumaScore/page/RevisedTraumaScore.page'
import StrokeScore from '../../features/initialAssessments/neuro/strokeScore/page/StrokeScore.page'
import VitalsStrokeScore from '../../features/vitals/strokeScore/page/StrokeScore.page'
import VitalsPainQuality from '../../features/vitals/painQuality/page/VitalsPainQuality.page'
import VitalsPainScalesPage from '../../features/vitals/PainScales/page/PainScales.page'
import Drain from '../../features/procedures/drain/page/Drain.page'
import Titrate from '../../features/procedures/titrate/page/Titrate.page'
import Labs from '../../features/procedures/labs/page/labs.page'
import PnProcedure from '../../features/procedures/pnProcedure/Page/PnProcedure.page'
import PNMedication from '../../features/procedures/pnMedication/page/pnMedication.page'
import DoNotResuscitate from '../../features/patientDemographics/doNotResuscitateSection/DoNotResuscitateMain.component'
import Exposure from '../../features/exposure/page/Exposure.page'
import BarriersToCare from '../../features/patientDemographics/barriersToCare/BarriersToCareMain.component'
import { getUserSelector } from '../../features/user/selectors'
import { AuthenticationService } from '../../features/login/services/authentication.service'
import { isChartTabSelected } from '../../utilities/router.util'
import System from '../../features/diagnosis/components/System.component'
import Symptoms from '../../features/diagnosis/components/Symptoms.component'
import Impression from '../../features/diagnosis/components/Impression.component'
import AdditionalAssessments from '../../features/additionalAssessments/page/AdditionalAssessments.page'
import AdditionalAssessmentSummary from '../../features/additionalAssessments/additionalAssessmentSummary/AdditionalAssessmentSummary.component'
import Fluids from '../../features/fluids/page/Fluids.page'
import BodyAssessmentPage from '../../features/additionalAssessments/bodyAssessment/page/BodyAssessment.page'
import CommentsPage from '../commentSection/commentsPage/CommentsPage.component'
import InjuryCause from '../../features/ccHpi/InjuryDetails/injuryCause/InjuryCause.component'
import NemsisCustomDataPage from '../../features/nemsisData/page/NemsisCustomData.page'
import CompleteChart from '../../features/completeChart/page/CompleteChart.page'
import SignerAndSecurityQuestions from '../../features/completeChart/component/SignerAndSecurityQuestions.component'
import Share from '../../features/share/page/Share.page'
import BloodProductAdministration from '../../features/procedures/bloodProductAdministration/page/BloodProductAdministration.page'
import VentricularAssistDevice from '../../features/procedures/ventricularAssistDevice/page/VentricularAssistDevice.page'
import CriticalCare from '../../features/procedures/criticalCare/page/criticalCare.page'
import Assessment from '../../features/procedures/assessment/page/Assessment.page'
import ProtectedRoute from '../errorBoundry/protectedRoute/ProtectedRoute.component'
import Logger from '../../services/logger.service'
import PreferredLanguagePage from '../../features/patientDemographics/preferredLanguage/PreferredLanguage.page'
import VitalsSedationScale from '../../features/vitals/sedationScale/page/VitalsSedationScale.page'
import WithdrawalScalePage from '../../features/vitals/withdrawalScale/page/withdrawalScale.Page'

const TabsComponent: React.FC = () => {
  const history = useHistory()
  const { location } = history
  const user = useSelector(getUserSelector)
  const submitChart = useSelector((state: IRootState) => state.submitChart)
  const { success } = submitChart

  const allowSecureRoutes = AuthenticationService.allowSecureRoutes(user)

  useEffect(() => {
    let content: HTMLIonContentElement | null = document.querySelector(':not(.ion-page-hidden) > ion-content')
    content?.scrollToTop(0)
    content = null
  }, [location?.pathname])

  useEffect(() => {
    if (!allowSecureRoutes) {
      Logger.warn('User is not authenticated. Redirecting to index route.')
      history.push(AppRouterConstants.INDEX_ROUTE)
    }
  }, [allowSecureRoutes])

  const currentURL: string = location?.pathname || ''
  const isChartSelected = isChartTabSelected(currentURL)
  const isAttachSelected = currentURL === TabConstants.ATTACHMENT_TAB
  const isCompleteChartSelected = currentURL === TabConstants.COMPLETE_CHART_TAB

  return (
    <IonTabs>
      <IonRouterOutlet>
        <Redirect exact path={TabConstants.HOME_TAB} to={AppRouterConstants.HOME_ROUTE} />
        <ProtectedRoute path={TabConstants.CHART_ROUTE} component={FullChart} />
        <ProtectedRoute path={TabConstants.TIMELINE_TAB} component={Timeline} />
        <ProtectedRoute path={TabConstants.TIMES_TAB} component={Times} />
        <ProtectedRoute path={TabConstants.QUICK_ACTIONS_TAB} component={QuickActions} />
        <ProtectedRoute path={TabConstants.ATTACHMENT_TAB} component={Attach} />
        <ProtectedRoute path={TabConstants.COMPLETE_CHART_TAB} component={CompleteChart} />
        <ProtectedRoute path={TabConstants.SIGNER_TAB} component={SignerAndSecurityQuestions} />
        <ProtectedRoute path={TabConstants.SHARE_TAB} component={Share} />
        <ProtectedRoute path={TabConstants.VITALS_TAB} component={Vitals} />
        <ProtectedRoute path={TabConstants.TIMELINE_ACTIONS_SEARCH} component={ActionsSearch} />
        <ProtectedRoute path={TabConstants.TRIP_INFORMATION} component={TripInformation} />
        <ProtectedRoute path={TabConstants.EXPOSURE} component={Exposure} />
        <ProtectedRoute path={TabConstants.NEMSIS_DATA} component={NemsisCustomDataPage} />
        <ProtectedRoute path={TabConstants.PICKUP_ADDRESS} component={PickupAddress} />
        <ProtectedRoute path={TabConstants.PATIENT_INFO_ROUTE} component={PatientInformation} />
        <ProtectedRoute path={QuickActionsConstants.CARDIAC_ARREST_ROUTE} component={CardiacArrest} />
        <ProtectedRoute path={QuickActionsConstants.QUICK_ACTION_BUTTONS_ROUTE} component={QuickActionButtons} />
        <ProtectedRoute path={TabConstants.PATIENT_DEMOGRAPHICS} component={PatientDemographics} />
        <ProtectedRoute path={TabConstants.PATIENT_ALLERGIES} component={PatientAllergies} />
        <ProtectedRoute path={TabConstants.PATIENT_ALLERGIES_LIST} component={PatientAllergiesSearchList} />
        <ProtectedRoute path={TabConstants.PATIENT_MEDICAL_HISTORY} component={PatientMedicalHistory} />
        <ProtectedRoute path={TabConstants.MEDICAL_HISTORY_LOOKUP} component={MedicalHistoryLookup} />
        <ProtectedRoute path={TabConstants.DO_NOT_RESUSCITATE} component={DoNotResuscitate} />
        <ProtectedRoute path={TabConstants.BARRIERS_TO_CARE} component={BarriersToCare} />
        <ProtectedRoute path={TabConstants.PREFERRED_LANGUAGE} component={PreferredLanguagePage} />
        <ProtectedRoute path={TabConstants.PATIENT_MEDICATIONS} component={PatientMedications} />
        <ProtectedRoute path={TabConstants.PATIENT_MEDICATIONS_SEARCH} component={MedicationSearch} />
        <ProtectedRoute path={TabConstants.CARDIAC_PROCEDURE} component={CardiacProcedure} />
        <ProtectedRoute path={TabConstants.ADD_MEDICATIONS_ADMINISTERED} component={AddMedicationAdministered} />
        <ProtectedRoute path={TabConstants.INTUBATION_PROCEDURE} component={Intubation} />
        <ProtectedRoute path={TabConstants.AIRWAY_PROCEDURE} component={Airway} />
        <ProtectedRoute path={TabConstants.ASSESSMENT_PROCEDURE} component={Assessment} />
        <ProtectedRoute path={TabConstants.IMAGING_ULTRASOUND_PROCEDURE} component={ImagingUltrasoundProcedure} />
        <ProtectedRoute path={TabConstants.CHILDBIRTHOB_PROCEDURE} component={ChildbirthOB} />
        <ProtectedRoute path={TabConstants.INITIATE_IV_PROCEDURE} component={InitiateIV} />
        <ProtectedRoute path={TabConstants.IMMOBILIZATION_PROCEDURE} component={Immobilization} />
        <ProtectedRoute path={TabConstants.MEDICAL_CONSULT_PROCEDURE} component={MedicalConsult} />
        <ProtectedRoute path={TabConstants.EXTRICATION_PROCEDURE} component={Extrication} />
        <ProtectedRoute path={TabConstants.OPERATIONS_PROCEDURE} component={Operations} />
        <ProtectedRoute path={TabConstants.RESCUE_PROCEDURE} component={Rescue} />
        <ProtectedRoute path={TabConstants.VENTILATOR_PROCEDURE} component={Ventilator} />
        <ProtectedRoute path={TabConstants.CRITICAL_CARE_PROCEDURE} component={CriticalCare} />
        <ProtectedRoute path={TabConstants.HOSPITAL_NOTIFY_PROCEDURE} component={HospitalNotify} />
        <ProtectedRoute path={TabConstants.TITRATE_PROCEDURE} component={Titrate} />
        <ProtectedRoute path={TabConstants.WOUND_CARE_PROCEDURE} component={WoundCare} />
        <ProtectedRoute path={TabConstants.LABS_PROCEDURE} component={Labs} />
        <ProtectedRoute path={TabConstants.PERTINENT_NEGATIVE_PROCEDURE} component={PnProcedure} />
        <ProtectedRoute path={TabConstants.PAYMENT_INFORMATION} component={PaymentInformation} />
        <ProtectedRoute
          path={TabConstants.ADD_MEDICATIONS_ADMINISTERED_SEARCH}
          component={MedicationAdministeredSearch}
        />
        <ProtectedRoute path={TabConstants.PATIENT_NARRATIVE} component={PatientNarrative} />
        <ProtectedRoute path={TabConstants.CAD_IMPORT} component={CadImport} />
        <ProtectedRoute path={TabConstants.CC_HPI} component={CcHpi} />
        <ProtectedRoute path={TabConstants.CC_HPI_INJURY_CAUSE} component={InjuryCause} />
        <ProtectedRoute path={TabConstants.DESTINATION_ADDRESS} component={DestinationAddress} />
        <ProtectedRoute path={TabConstants.BILLING} component={PatientBilling} />
        <ProtectedRoute path={TabConstants.INSURANCE_INFORMATION} component={InsuranceInformation} />
        <ProtectedRoute path={TabConstants.RELATIONSHIPS_AND_GUARANTORS} component={RelationshipsAndGuarantors} />
        <ProtectedRoute path={TabConstants.PCS_INFORMATION} component={PcsInformation} />
        <ProtectedRoute path={TabConstants.AUTHORIZATION_INFORMATION} component={AuthorizationInformation} />
        <ProtectedRoute path={TabConstants.CMS_INFORMATION} component={CmsInformation} />
        <ProtectedRoute path={TabConstants.PATIENT_SEARCH} component={PatientSearch} />
        <ProtectedRoute path={TabConstants.PATIENT_SEARCH_RESULTS} component={PatientSearchResults} />
        <ProtectedRoute path={TabConstants.FACTORS_AFFECTING_CARE} component={FactorsAffectingCare} />
        <ProtectedRoute path={TabConstants.SCENE_DESCRIPTION} component={SceneDescription} />
        <ProtectedRoute path={TabConstants.INITIAL_ASSESSMENT} component={InitialAssessment} />
        <ProtectedRoute path={TabConstants.INITIAL_ASSESSMENT_COMMENTS} component={InitialAssessmentComments} />
        <ProtectedRoute path={TabConstants.GLASSGOW_COMMA_SCORE} component={GlassgowCommaScore} />
        <ProtectedRoute path={TabConstants.PEDIATRIC_TRAUMA_SCORE} component={PediatricCommaScore} />
        <ProtectedRoute path={TabConstants.REVISED_TRAUMA_SCORE} component={RevisedTraumaScore} />
        <ProtectedRoute path={TabConstants.STROKE_SCORE} component={StrokeScore} />
        <ProtectedRoute path={TabConstants.VITALS_STROKE_SCORE} component={VitalsStrokeScore} />
        <ProtectedRoute path={TabConstants.VITALS_PAIN_QUALITY} component={VitalsPainQuality} />
        <ProtectedRoute path={TabConstants.VITALS_PAIN_SCALES} component={VitalsPainScalesPage} />
        <ProtectedRoute path={TabConstants.VITALS_SEDATION_SCALE} component={VitalsSedationScale} />
        <ProtectedRoute path={TabConstants.VITALS_WITHDRAWAL_SCALES} component={WithdrawalScalePage} />
        <ProtectedRoute path={TabConstants.DRAIN_PROCEDURE} component={Drain} />
        <ProtectedRoute path={TabConstants.PN_MEDICATION_PROCEDURE} component={PNMedication} />
        <ProtectedRoute path={TabConstants.SYSTEM} component={System} />
        <ProtectedRoute path={TabConstants.SYMPTOMS} component={Symptoms} />
        <ProtectedRoute path={TabConstants.IMPRESSION} component={Impression} />
        <ProtectedRoute path={TabConstants.ADDITIONAL_ASSESSMENTS} component={AdditionalAssessments} />
        <ProtectedRoute path={TabConstants.ADDITIONAL_ASSESSMENT_SUMMARY} component={AdditionalAssessmentSummary} />
        <ProtectedRoute path={TabConstants.FLUIDS} component={Fluids} />
        <ProtectedRoute path={TabConstants.BODY_ASSESSMENT} component={BodyAssessmentPage} />
        <ProtectedRoute path={TabConstants.BODY_ASSESSMENT_COMMENTS} component={CommentsPage} />
        <ProtectedRoute
          path={TabConstants.BLOOD_PRODUCT_ADMINISTRATION_PROCEDURE}
          component={BloodProductAdministration}
        />
        <ProtectedRoute path={TabConstants.VENTRICULAR_ASSIST_DEVICE_PROCEDURE} component={VentricularAssistDevice} />
      </IonRouterOutlet>
      {/*todo: add strings to i18n*/}
      <IonTabBar slot='bottom'>
        <IonTabButton
          data-testid='Chart'
          layout='icon-start'
          selected={isChartSelected}
          tab='chart'
          href={TabConstants.CHART_ROUTE}
          disabled={success}>
          <IonIcon className='ion-no-margin' icon={readerOutline} />
          <IonLabel>Chart</IonLabel>
        </IonTabButton>

        <IonTabButton
          data-testid='Times'
          layout='icon-start'
          tab='times'
          href={TabConstants.TIMES_TAB}
          disabled={success}>
          <IonIcon className='ion-no-margin' icon={stopwatchOutline} />
          <IonLabel>Times</IonLabel>
        </IonTabButton>

        <IonTabButton
          data-testid='Quick Actions'
          layout='icon-start'
          tab='quickActions'
          href={TabConstants.QUICK_ACTIONS_TAB}
          disabled={success}>
          <IonIcon className='ion-no-margin' icon={bookmarkOutline} />
          <IonLabel>Quick Actions</IonLabel>
        </IonTabButton>

        <IonTabButton
          data-testid='Attach'
          layout='icon-start'
          tab='attachment'
          selected={isAttachSelected}
          href={TabConstants.ATTACHMENT_TAB}
          disabled={success}>
          <IonIcon className='ion-no-margin' icon={attachOutline} />
          <IonLabel>Attach</IonLabel>
        </IonTabButton>

        <IonTabButton
          data-testid='Share'
          layout='icon-start'
          tab='share'
          selected={isCompleteChartSelected}
          href={TabConstants.COMPLETE_CHART_TAB}
          disabled={success}>
          <IonIcon className='ion-no-margin' icon={shareOutline} />
          <IonLabel>Complete</IonLabel>
        </IonTabButton>
      </IonTabBar>
    </IonTabs>
  )
}
export default TabsComponent
